module.exports = __webpack_public_path__ + "img/login-cover.098c3b14.png";